import { takeEvery } from "redux-saga/effects";
import { TYPES } from "store/types";
import { login, logout } from "./auth";
import { setColorSage } from "./color";
import { setFilterConditionSaga } from "./filter";
import { setSortConditionSaga } from "./sort";
import {
  getListLocationProjectSaga,
  getListStatusProjectSaga,
} from "./project";
import { setFavoriteConditionSaga } from "./favorite";
import { setBarcodeSage } from "./barcode";
import { setDevanSearchConditionSaga } from "./devanSearch";
import { setSignaturePenSizeConditionSaga } from "./template";
import { setIncidentDamageReportSaga } from "./IncidentDamageReport";
import { setSettingIncidentDamageItemData } from "./setting"
import { setContractInfoSaga, clearContractInfoSaga } from "./contract"

const watcher = [
  takeEvery(TYPES.LOGIN, login),
  takeEvery(TYPES.LOGOUT, logout),
  takeEvery(TYPES.SET_MASTER_COLOR_DATA, setColorSage),
  takeEvery(TYPES.SET_FILTER_CONDITION, setFilterConditionSaga),
  takeEvery(TYPES.SET_SORT_CONDITION, setSortConditionSaga),
  takeEvery(TYPES.GET_LIST_STATUS_PROJECT, getListStatusProjectSaga),
  takeEvery(TYPES.GET_LIST_LOCATION, getListLocationProjectSaga),
  takeEvery(TYPES.SET_FAVORITE_CONDITION, setFavoriteConditionSaga),
  takeEvery(TYPES.SET_2D_BARCODE_LAYOUT, setBarcodeSage),
  takeEvery(TYPES.SET_DEVAN_SEARCH_CONDITION, setDevanSearchConditionSaga),
  takeEvery(TYPES.SET_SIGNATURE_PEN_SIZE, setSignaturePenSizeConditionSaga),
  takeEvery(TYPES.SET_INCIDENT_DAMAGE_REPORT, setIncidentDamageReportSaga),
  takeEvery(TYPES.SET_INCIDENT_DAMAGE_REPORT, setSettingIncidentDamageItemData),
  takeEvery(TYPES.CONTRACT_LOGIN, setContractInfoSaga),
  takeEvery(TYPES.CONTRACT_LOGOUT, clearContractInfoSaga),
];

export default watcher;
